<ng-container *ngIf="showHeader">
    <div class="app-card-header"
         #header
         [class.app-card-header--empty]="!header.textContent"
         [class.app-card-header--clickable]="headerClick.observed"
         (click)="headerClick.emit($event)"
         (dblclick)="headerDoubleClick.emit($event)"
         (contextmenu)="headerContextMenu.emit($event)">
        <ng-content select="[appCardIcon]"></ng-content>
        <ng-content select="[appCardAvatar]"></ng-content>

        <div class="app-card-header-title-container">
            <ng-content select="app-card-title,[appCardTitle]"></ng-content>
            <ng-content select="app-card-subtitle"></ng-content>
        </div>

        <ng-content select="app-card-header-actions"></ng-content>
    </div>
</ng-container>

<div #cardContent class="app-card-content"
     *ngIf="showContent"
     [@.disabled]="!animateContent"
     [@expand]="showContent ? 'showing' : 'hidden'">
    <ng-content></ng-content>
</div>

<ng-content select="app-card-actions"></ng-content>
